import DestructorTree from "../DestructorTree";
import { api_configuration } from "../../common";
import { createLocalNode } from "./addClientState";
import cs = api_configuration.types.client_state.alan_api;
import { applyOperationDefaults } from "./defaults";
import { registerNewNode } from "./registerClientState";
import { nodeValid } from "../state/subscribeToNodePropertyValid";

export function startOperation(
	operation: cs.Coperation__type__attributes,
	destructor: DestructorTree
): cs.Cyes__started {
	const result = operation.properties.started.switch({
		yes: ($) => {
			const $2 = patchDependencyCount($);
			$2.dependency_count += 1;
			return $;
		},
		no: () => {
			const started_operation = patchDependencyCount(
				operation.properties.started.set("yes", {
					"is valid": ["yes", {}],
					node: createLocalNode(operation.properties.type.state.node.output.parameter_definition(), ["local", {}]),
					executing: [
						"no",
						{
							"last result": ["not invoked", {}],
						},
					],
					executable: "no",
				})
			);
			const started_operation_destructor = new DestructorTree();
			started_operation.onDestroy(() => {
				started_operation_destructor.destroy();
			});
			started_operation.sub = nodeValid(started_operation.properties.node).subscribe({
				update: (valid) => {
					started_operation.properties.is_valid.ensure(valid ? "yes" : "no", {});
				},
			});
			operation.root.transact(() => registerNewNode(started_operation.properties.node, started_operation_destructor));
			started_operation.dependency_count = 1;
			applyOperationDefaults(started_operation);
			subscribeExecutableStatus(started_operation);
			return started_operation;
		},
	});
	destructor.onDestroy(() => {
		if (operation.destroyed) {
			return;
		}
		const o = patchDependencyCount(result);
		o.dependency_count -= 1;
		if (o.dependency_count === 0) {
			nodeValid(o.properties.node).unsubscribe(o.sub);
			stopOperation(operation);
		}
	});
	return result;
}

function patchDependencyCount(started_operation: cs.Cyes__started) {
	return started_operation as any as cs.Cyes__started & {
		dependency_count: number;
		sub: { update: (valid: boolean) => void };
	};
}

function stopOperation(operation: cs.Coperation__type__attributes): void {
	if (operation.destroyed) return;
	operation.properties.started.set("no", {});
}

function subscribeExecutableStatus(operation: cs.Cyes__started): void {
	let command_exeute_permitted = true;
	const is_executable = (): boolean => {
		let executable = command_exeute_permitted;
		if (!executable) {
			return executable;
		}
		switch (operation.properties.is_valid.state.name) {
			case "no": {
				executable = false;
				break;
			}
			case "yes": {
				executable = executable && true;
				break;
			}
			default:
				unexpectedState(operation.properties.is_valid.state);
		}
		if (!executable) {
			return executable;
		}
		switch (operation.properties.executing.state.name) {
			case "no": {
				executable = executable && true;
				break;
			}
			case "yes": {
				executable = false;
				break;
			}
			default:
				unexpectedState(operation.properties.executing.state);
		}
		return executable;
	};
	const update_executable = () => {
		const executable = is_executable();
		switch (operation.properties.executable.state.name) {
			case "no": {
				if (executable) {
					operation.properties.executable.set("yes", {});
				}
				break;
			}
			case "yes": {
				if (!executable) {
					operation.properties.executable.set("no", {});
				}
				break;
			}
			default:
				unexpectedState(operation.properties.executable.state);
		}
	};
	switch (operation.parent.properties.type.state.name) {
		case "action": {
			break;
		}
		case "command": {
			const $ = operation.parent.properties.type.state.node;
			const permission_subscription = $.properties.execute_permitted.subscribe({
				on_update: () => {
					switch ($.properties.execute_permitted.state.name) {
						case "no": {
							command_exeute_permitted = false;
							break;
						}
						case "yes": {
							command_exeute_permitted = true;
							break;
						}
						default:
							unexpectedState($.properties.execute_permitted.state);
					}
					update_executable();
				},
			});
			operation.onDestroy(() => permission_subscription.unsubscribe());
			break;
		}
		default:
			unexpectedState(operation.parent.properties.type.state);
	}
	operation.properties.is_valid.subscribe({
		on_update: update_executable,
	});
	operation.properties.executing.subscribe({
		on_update: update_executable,
	});
}
